/*
 *   Copyright (c) 2024 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
// @ts-nocheck
/**
 * Auto Generated Routes of the project
 */

/**
 * Adonis Typings
 */
type MultipartFileContract = any

type ModelPaginatorContract<T extends any> = {
  meta: {
    total: number
    per_page: number
    current_page: number
    last_page: number
    first_page: number
    first_page_url: string | null
    last_page_url: string | null
    next_page_url: string | null
    previous_page_url: null
  }
  data: T[]
}

type DateTime = string

/**
 * Common Types (Related to controllers/routes/models)
 */
export enum BillTypeEnum {
  p2p = 'p2p',
  p2a = 'p2a',
}
export enum BillStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}
export enum CreditNoteStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}
export type ExpoPushComposeType = Omit<ExpoPushMessage, 'to'> & {
  to?: ExpoPushMessage['to']
}
export type EmailComposeType = {
  from?: string
  to: EmailId
  subject: string
  htmlView?: {
    template: string
    data: Object
  }
  textView?: {
    template: string
    data: Object
  }
  attachments?: {
    document_storage_disk_id: number
    document_location: string
  }[]
}
export enum NotificationStatusEnum {
  none = 'none', //default status
  dispatched = 'dispatched',
  processing = 'processing',
  pending = 'pending',
  success = 'success',
  failed = 'failed',
}
export enum StatusEnum {
  processing = 'processing',
  none = 'none',
  success = 'success',
  failed = 'failed',
  pending = 'pending',
  dispatched = 'dispatched',
  review = 'review',
}

export enum BillStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}

export enum BillTypeEnum {
  p2p = 'p2p',
  p2a = 'p2a',
}

export enum CreditNoteStatusEnum {
  none = 'none',
  sequence_generated = 'sequence_generated',
  filed = 'filed',
  document_generated = 'document_generated',
}

export enum BookPromotionalEnum {
  discount = 'discount', //for p2a
}

export enum NotificationStatusEnum {
  none = 'none', //default status
  dispatched = 'dispatched',
  processing = 'processing',
  pending = 'pending',
  success = 'success',
  failed = 'failed',
}
export interface orderPGStatType {
  is_computed: true | false
  isPaid: boolean
  actualAmount: number
  paidAmount: number
  payableAmount: number
  pendingOrderItemsCount: number
  actions: {
    hold_amount: number
    is_withdrawable: boolean
    can_process_order: boolean
  }
}
type googleAdsEnvTypes = {
  client_id: string
  client_secret: string
  developer_token: string
  refresh_token: string
  customer_id: string
  login_customer_id: string
  conversionActionId: string
}

/**
 * Model Types
 */

export interface Airport {
  id: number
  name: string
  city: string
  city_code: string
  location: string | null
  country: string
  country_code: string
  iata: string | null
  icao: string | null
  latitude: number | null
  longitude: number | null
  altitude: number | null
  timezone: string | null
  daylight_saving_time: string | null
  dz_database_time: string | null
  type: string | null
  source: string
  is_popular: boolean
  country_meta?: Country | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface Country {
  id: number
  code: string
  name: string
  created_at: DateTime
  updated_at: DateTime
}

export interface CountryHoliday {
  id: number
  country_code: string
  holiday_date: DateTime
  reason: string
  createdAt: DateTime
  updatedAt: DateTime
}

export interface CountryVisaDetail {
  id: number
  origin_country: string
  destination_country: string
  source_key: string
  name: string
  entry_type: string
  validity: string
  period: string
  price_purpose: string
  currency: string
  supported: boolean
  fee: number
  child_fee: number
  visa_fee: number
  visa_child_fee: number
  visa_currency: string
  entry_length_stay_amount: number
  entry_length_stay_unit: string
  entry_validity_units: string
  entry_validity_amount: number
  is_multiple_entry: boolean
  from_currency: string
  to_currency: string
  eta_duration: number | null
  undefined: any
  eta_unit: 'month' | 'day' | 'hour' | 'minute' | 'months' | 'days' | 'hours' | 'minutes'
  eta_b2b_duration: number | null
  eta_b2b_unit: 'month' | 'day' | 'hour' | 'minute' | 'months' | 'days' | 'hours' | 'minutes'
  service_fee_per_person: number
  priority: number
  child_fee_inr: number
  visa_fee_inr: number
  visa_child_fee_inr: number
  country_meta?: Country | null
  $document_links?: CountryVisaDetailAndDocumentLink[] | null
  $holidays?: CountryHoliday[] | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface CountryVisaDetailAndDocumentLink {
  id: number
  country_visa_detail_id: number
  document_id: number
  document_meta?: Document | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface Document {
  id: number
  amount: number
  chargeable: boolean
  currency: string
  family_enabled: boolean
  key: string
  label: string
  only_b2b: boolean
  only_b2c: boolean
  only_indigo: boolean
  createdAt: DateTime
  updatedAt: DateTime
}

export interface ExchangeRate {
  id: number
  from: string
  to: string
  rate: number
  last_updated: DateTime
  createdAt: DateTime
  updatedAt: DateTime
}

export interface FileUpload {
  id: number
  hash: string
  name: string
  size: number
  guest_uuid: string | null
  device_uuid: string | null
  user_id: number | null
  document_storage_disk_id: number | null
  document_location: string | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface OrderItem {
  id: number
  order_id: number
  item: 'wallet' | 'visa' | 'manual'
  sub_item_code: number
  bill_type: BillTypeEnum
  priority_order: number
  additional_info: any
  provider_id: number
  delivery_status: 'none' | 'dispatched' | 'processing' | 'pending' | 'success' | 'failed' | 'review'
  is_shadow_pending: boolean
  operator_ref: string
  failed_reason: string
  currency: 'INR'
  base_amount: number
  base_discount: number
  coupon_discount: number
  pg_discount: number
  processing_fee: number
  discount: number
  total_amount: number
  pg_amount_used: number
  refund_noservice_amount: number
  refund_serviced_amount: number
  refund_total_amount: number
  ledger_amount: number
  api_last_hit: string
  is_aborted: boolean
  is_locked: boolean
  vendor: 'rcwallet' | 'devTestMode' | 'visa_hook' | null
  vendor_order_id: string | number
  is_bill_generated: boolean
  dependency_order_item_id: number
  recheck_status_sequence: number
  recheck_status_schedule_at: DateTime
  processed_at: DateTime | null
  success_at: DateTime | null
  failed_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  ai_wallet?: OrderItemWallet | null
  ai_visa?: OrderItemVisa | null
  ai_manual?: OrderItemVisa | null
  payment_links?: OrderItemPaymentLink[] | null
  book_bills?: BookBill[] | null
  book_credit_notes?: BookCreditNote[] | null
  book_promotional_expenses?: BookPromotionalExpense[] | null
  googleAdsConversionMeta?: GoogleAdsConversion | null
  googleAdsConversionAdjustmentMeta?: GoogleAdsConversionAdjustment | null
  order_meta?: Order | null
}

export interface OrderItemVisa {
  id: number
  order_item_id: number
  origin_country_code: string
  country_code: string
  source_key: string
  first_name: string
  last_name: string
  mobile_no: string
  email: string
  pan_no: string | undefined
  passport_no: string | undefined
  other_doc_details: { [key: string]: string }
  visa_final_status: 'pending' | 'success' | 'rejected'
  document_id: number
  document_hash: string
  country_meta?: Country | null
  visa_details_meta?: CountryVisaDetail | null
  $document_links?: OrderItemVisaDocument[] | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface OrderItemVisaDocument {
  id: number
  order_item_visa_id: number
  document_type: string
  document_id: number
  document_hash: string
  file_meta?: FileUpload | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface AdonisSchema {
  id: number
  name: string
  batch: number
  migration_time: DateTime
}

export interface ApiToken {
  id: number
  user_id: number
  name: string
  type: string
  token: string
  ip: string | null
  expo_version: string | null
  user_agent_id: number
  device_id: number
  guest_uuid: string | null
  device_uuid: string | null
  expires_at: DateTime
  createdAt: DateTime
  updatedAt: DateTime
  clientDeviceInfoMeta?: ClientDeviceInfo | null
  userAgentMeta?: ClientUserAgent | null
}

export interface BannedIp {
  id: number
  ip: string
  reason: 'spam' | 'fraud' | 'other' | 'invalid' | 'duplicate'
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface BookBill {
  id: number
  user_id: number | null
  order_id: number
  order_item_id: number
  order_item_code: 'wallet' | 'visa' | 'manual'
  order_item_sub_code: number
  bill_for: 'service' | 'pf'
  bill_type: BillTypeEnum
  bill_number: number | null
  bill_number_full: string | null
  bill_supplier_id: number
  bill_date: DateTime
  bill_to_gst_number: string | null
  bill_to_state_code: string | null
  bill_to_gst_state_code: string | null
  bill_to_country_code: string | null
  bill_status: BillStatusEnum
  irn: string
  ack_no: string
  ack_date: DateTime
  sac_code: string | null
  hsn_code: string | null
  base_amount: number
  after_tax_discount: number
  after_tax_processing_fee: number
  cgst_rate: number
  cgst_amount: number
  cess_rate: number
  cess_amount: number
  igst_rate: number
  igst_amount: number
  sgst_rate: number
  sgst_amount: number
  before_tax_amount: number
  before_tax_discount: number
  before_tax_processing_fee: number
  taxable_amount: number
  after_tax_amount: number
  document_storage_disk_id: number | null
  document_location: string | null
  created_at: DateTime
  updated_at: DateTime
  documentStorageMeta?: StorageDisk | null
  credit_notes?: BookCreditNote[] | null
  orderItem?: OrderItem | null
  supplier_meta?: BookSupplier | null
}

export interface BookCreditNote {
  id: number
  user_id: number | null
  order_id: number
  order_item_id: number
  order_item_code: 'wallet' | 'visa' | 'manual'
  order_item_sub_code: number
  book_bill_id: number
  credit_note_status: CreditNoteStatusEnum
  credit_note_number: number | null
  credit_note_number_full: string | null
  credit_note_date: DateTime | null
  irn: string | null
  ack_no: string | null
  ack_date: string | null
  bill_supplier_id: number
  bill_for: 'service' | 'pf'
  bill_type: BillTypeEnum
  bill_to_gst_number: string | null
  bill_to_state_code: string | null
  bill_to_gst_state_code: string | null
  bill_to_country_code: string | null
  sac_code: string | null
  hsn_code: string | null
  cgst_rate: number
  cgst_amount: number
  cess_rate: number
  cess_amount: number
  igst_rate: number
  igst_amount: number
  sgst_rate: number
  sgst_amount: number
  before_tax_amount: number
  before_tax_discount: number
  before_tax_processing_fee: number
  taxable_amount: number
  after_tax_amount: number
  document_storage_disk_id: number | null
  document_location: string | null
  created_at: DateTime
  updated_at: DateTime
  documentStorageMeta?: StorageDisk | null
  supplier_meta?: BookSupplier | null
  billMeta?: BookBill | null
}

export interface BookPromotionalExpense {
  id: number
  order_id: number
  order_item_id: number
  bill_supplier_id: number
  type: BookPromotionalEnum
  amount: number
  reason: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface BookSupplier {
  id: number
  order_id: number
  legal_name: string
  legal_cin_number: string
  tax_gst_number: string
  tax_pan_number: string
  tax_gst_state_code: string
  tax_country_code: string
  address_line_1: string
  address_line_2: string
  address_line_3: string
  city_full: string
  state_full: string
  pin_code: string
  country_full: string
  is_primary: boolean
  last_financial_year: number
  bill_p2p_prefix: string
  bill_p2a_prefix: string
  credit_note_p2p_prefix: string
  credit_note_p2a_prefix: string
  last_bill_date: DateTime
  last_credit_date: DateTime
  last_bill_p2p_sequence: number
  last_bill_p2a_sequence: number
  last_credit_p2p_sequence: number
  last_credit_p2a_sequence: number
  created_at: DateTime
  updated_at: DateTime
}

export interface ClientDeviceInfo {
  id: number
  platform_os: string | null
  brand: string | null | undefined
  designName: string | null | undefined
  deviceYearClass: number | null | undefined
  isDevice: boolean | null | undefined
  manufacturer: string | null | undefined
  modelId: string | null | undefined
  modelName: string | null | undefined
  osBuildFingerprint: string | null | undefined
  osBuildId: string | null | undefined
  osInternalBuildId: string | null | undefined
  osName: string | null | undefined
  osVersion: string | null | undefined
  platformApiLevel: number | null | undefined
  productName: string | null | undefined
  created_at: DateTime
  updated_at: DateTime
}

export interface ClientUserAgent {
  id: number
  user_agent: string
  created_at: DateTime
  updated_at: DateTime
}

export interface CouponCode {
  id: number
  type: 'public' | 'private' | 'signup'
  public_code: string
  coupon_definition_id: number
  config: {}
  created_at: DateTime
  updated_at: DateTime
  user_id: number
  coupon_definition_meta?: CouponDefinition | null
}

export interface CouponDefinition {
  id: number
  hook_code: string
  title: string
  description: string
  validity: DateTime
  config: {}
  created_at: DateTime
  updated_at: DateTime
}

export interface CouponShowcase {
  id: number
  coupon_code_id: number
  utm_id: number
  item: 'wallet' | 'visa' | 'manual'
  item_code: string | number | null
  platform: 'rc' | 'rm'
  created_at: DateTime
  updated_at: DateTime
  coupon_code_meta?: CouponCode | null
}

export interface EnvSetting {
  key: string
  value: string
  jsonData: any
  safeData: any
  is_locked: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface GoogleAdsCampaign {
  id: number
  campaign_id: number
  campaign_name: string
  status: enums.CampaignStatus
  item: 'wallet' | 'visa' | 'manual'
  sub_item_code: number
  paused_at: DateTime | null
  last_paused_notification_time: DateTime | null
  next_paused_notification_time: DateTime | null
  main_utm_id: number | null
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface GoogleAdsConversion {
  id: number
  order_item_id: number
  status: 'none' | 'pending' | 'success' | 'failed' | 'skipped'
  request: services.IUploadClickConversionsRequest | null
  undefined: any
  response: services.UploadClickConversionsResponse | null
  scheduled_at: DateTime
  is_fixed: boolean
  created_at: DateTime
  updated_at: DateTime
  orderItemMeta?: OrderItem | null
}

export interface GoogleAdsConversionAdjustment {
  id: number
  order_item_id: number
  google_ads_conversion_id: number
  status: 'none' | 'pending' | 'success' | 'failed' | 'skipped'
  type: 'RETRACTION'
  request: services.IConversionAdjustment | null
  undefined: any
  response: services.UploadConversionAdjustmentsResponse | null
  scheduled_at: DateTime
  created_at: DateTime
  updated_at: DateTime
  orderItemMeta?: OrderItem | null
}

export interface GoogleAdsItemReflector {
  id: number
  item: 'wallet' | 'visa' | 'manual'
  sub_item_code: number
  max_pending: number
  max_failed: number
  pending_count: number
  failed_count: number
  created_at: DateTime
  updated_at: DateTime
}

export interface Notification {
  id: number
  user_id: number | undefined
  staff_id: number | undefined
  type: keyof {
    OrderItem: OrderItem
    OrderItemTicket: OrderItemTicket
    UserAuth: any
  }
  about: string
  created_at: DateTime
  updated_at: DateTime
  deliveries?: NotificationDelivery[] | null
}

export interface NotificationDelivery {
  id: number
  notification_id: number
  user_id: number | null | undefined
  staff_id: number | null | undefined
  hook_code: keyof NotificationHookMetaType
  hook_compose: any
  status: NotificationStatusEnum
  hook_response: Object | null
  hook_response_id: string | undefined
  is_locked: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface NotificationSubscription {
  id: number
  user_id: number | undefined
  staff_id: number | undefined
  hook_code: any
  hook_subscription_key: string
  is_promotional_allowed: boolean
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface NotificationTokenExpo {
  expo_token: string
  device_id: number
  user_id: number | undefined
  staff_id: number | undefined
  api_token_id: number
  createdAt: DateTime
  undefined: any
  updatedAt: DateTime
  clientDeviceInfoMeta?: ClientDeviceInfo | null
  user_meta?: User | null
  staff_meta?: Staff | null
  userApiTokenMeta?: ApiToken | null
}

export interface Order {
  id: number
  order_key: string
  user_id: number | undefined
  staff_id: number | null | undefined
  currency: 'INR'
  total_oi_amount: number
  coupon_id: number | null
  undefined: any
  payment_status: 'none' | 'pending' | 'success' | 'initiated' | 'mismatch' | 'delayed'
  paid_amount_virtual: number
  paid_amount_actual: number
  paid_amount_total: number
  refund_amount_total: number
  ledger_amount: number
  api_process_required: boolean
  api_processing: boolean
  api_processed: boolean
  tax_processed: boolean
  api_tag1: string
  api_tag2: string
  api_tag3: string
  api_tag4: string
  is_locked: boolean
  platform: 'rc' | 'rm'
  device: 'web' | 'app'
  utm_id: number
  guest_uuid: string | null
  device_uuid: string | null
  user_ip: string | null
  has_displayed_utm_code: boolean
  gclid: string | null
  created_at: DateTime
  updated_at: DateTime
  items?: OrderItem[] | null
  bill_detail?: OrderBillDetail | null
  ship_detail?: OrderShipDetail[] | null
  payment_wall?: PaymentWall[] | null
  coupon_meta?: CouponCode | null
  actions?: OrderAction[] | null
  refunds?: OrderRefund[] | null
  order_cashbacks?: OrderCashback[] | null
  guest_cashbacks?: OrderGuestCashback[] | null
  scratchMyRewards?: ScratchMyReward[] | null
  feedback?: OrderFeedback | null
  staff?: Staff | null
  book_bills?: BookBill[] | null
  book_credit_notes?: BookCreditNote[] | null
  pre_payment_config: {
    wallet_used: { wallet_id: number; amount: number; pw_id: number }[]
    pg_amount: number
    wallet_amount: number
    coupon_amount: number
    isComputed: boolean
  }
  is_refund_required: boolean
  refund_scheduled_at: DateTime
  user_meta?: User | null
}

export interface OrderAction {
  id: number
  order_id: number
  order_item_id: number
  action_type: string
  staff_id: number
  user_comment: string
  system_comment: string
  staff?: Staff | null
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderBillDetail {
  id: number
  order_id: number
  legal_name: string
  tax_gst_number: string | null
  tax_pan_number: string | null
  tax_gst_state_code: string | null
  tax_country_code: string
  mobile_number: string
  email: string
  addressLine1: string | null
  addressLine2: string | null
  addressLine3: string | null
  city: string
  state: string
  pin_code: string
  country: string
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderCashback {
  id: number
  order_id: number
  wallet_id: number
  currency: 'INR'
  amount: number
  reversed_amount: number
  scheduled_at: DateTime
  is_credited: boolean
  is_locked: boolean
  created_at: DateTime
  updated_at: DateTime
  wallet_meta?: Wallet | null
  order_meta?: Order | null
}

export interface OrderFeedback {
  id: number
  order_id: number
  user_id: number | null
  guest_uuid: string | null
  device_uuid: string | null
  user_ip: string | null
  rating: 2 | 1 | 3 | 4 | 5
  feedback: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderGuestCashback {
  id: number
  order_id: number
  wallet_type: 'money' | 'promo' | 'voucher'
  currency: 'INR'
  amount: number
  reversed_amount: number
  is_credited: boolean
  created_at: DateTime
  updated_at: DateTime
  order_meta?: Order | null
}

export interface _OrderItem {
  id: number
  order_id: number
  item: 'wallet' | 'visa' | 'manual'
  sub_item_code: number
  bill_type: BillTypeEnum
  priority_order: number
  additional_info: any
  provider_id: number
  delivery_status: 'none' | 'dispatched' | 'processing' | 'pending' | 'success' | 'failed' | 'review'
  operator_ref: string
  failed_reason: string
  currency: 'INR'
  base_amount: number
  base_discount: number
  coupon_discount: number
  pg_discount: number
  processing_fee: number
  discount: number
  total_amount: number
  pg_amount_used: number
  refund_noservice_amount: number
  refund_serviced_amount: number
  refund_total_amount: number
  ledger_amount: number
  api_last_hit: string
  is_aborted: boolean
  is_locked: boolean
  vendor: 'rcwallet' | 'devTestMode' | 'visa_hook' | null
  vendor_order_id: string | number
  is_bill_generated: boolean
  dependency_order_item_id: number
  recheck_status_sequence: number
  recheck_status_schedule_at: DateTime
  processed_at: DateTime | null
  success_at: DateTime | null
  failed_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  ai_wallet?: OrderItemWallet | null
  payment_links?: OrderItemPaymentLink[] | null
  book_bills?: BookBill[] | null
  book_credit_notes?: BookCreditNote[] | null
  book_promotional_expenses?: BookPromotionalExpense[] | null
  googleAdsConversionMeta?: GoogleAdsConversion | null
  googleAdsConversionAdjustmentMeta?: GoogleAdsConversionAdjustment | null
  order_meta?: Order | null
}

export interface OrderItemCancellation {
  id: number
  order_id: number
  order_item_id: number
  vendor: 'tbo_flight'
  vendor_credit_note_id: string
  cancellation_charge: number
  refund_amount: number
  order_meta?: Order | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface OrderItemPaymentLink {
  id: number
  order_item_id: number
  payment_wall_id: number
  used_amount: number
  created_at: DateTime
  updated_at: DateTime
  payment_wall_meta?: PaymentWall | null
}

export interface OrderItemWallet {
  id: number
  order_item_id: number
  wallet_id: number
  amount: number
  created_at: DateTime
  updated_at: DateTime
  wallet_meta?: Wallet | null
}

export interface OrderRefund {
  id: number
  order_id: number
  mode: 'wallet' | 'manual' | 'cashgram' | 'original'
  amount: number
  status: StatusEnum
  bank_ref: string | number | undefined
  refund_reason: string
  refund_fail_reason: string | null
  is_locked: boolean
  api_res_data: any
  recheck_status_sequence: number | null
  recheck_status_schedule_at: DateTime
  vendor_request_id: string
  vendor_processed_at: DateTime | null
  processed_at: DateTime | null
  success_at: DateTime | null
  failed_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  paymentWallLink?: OrderRefundPaymentLink[] | null
  order_meta?: Order | null
}

export interface OrderRefundPaymentLink {
  id: number
  refund_id: number
  payment_wall_id: number
  used_amount: number
  payment_wall_meta?: PaymentWall | null
  created_at: DateTime
  updated_at: DateTime
}

export interface OrderShipDetail {
  id: number
  order_id: number
  first_name: string
  last_name: string
  mobile_number: string
  email: string
  addressLine1: string
  addressLine2: string
  addressLine3: string
  city: string
  state: string
  pin_code: string
  country: string
  is_primary: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface OtpValidation {
  id: number
  code: string
  user_id: number
  type: 'login' | 'change_email'
  mobile: string
  email: string
  config: { type: 'change_email'; newEmail: string } | undefined
  isVerified: boolean
  isSentOnMobile: boolean
  isSentOnEmail: boolean
  sentAt: DateTime
  attempts: number
  created_at: DateTime
  updated_at: DateTime
}

export interface PaymentBankCode {
  id: number
  bank_name: string
  order: string
  bank_type: string
  payubiz: string
  traknpay: string
  cashFree: string
  default: string
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface PaymentWall {
  id: number
  order_id: number
  gateway_payment_id: string
  gateway_payment_id2: string
  payment_status: 'none' | 'pending' | 'success' | 'failed' | 'cancelled'
  currency: 'INR'
  amount: number
  remaining_amount: number
  it_error_code: string
  pg_method: string
  pg_bank_utr: string | null
  pg_sub_gateway_provider: string
  pg_vpa: string | null
  pg_bank: string | null
  pw_card_id: number | null
  pg_wallet: string | null
  pg_error_code: string
  pg_error_message: string
  us_is_debited: boolean
  us_is_cancelled: boolean
  it_pg_channel: 'cashfree' | 'self' | 'payubiz' | 'razorpay' | 'phonepe' | undefined
  us_pg_mode: string
  us_pg_code: string | number
  us_away_time: DateTime
  us_back_time: DateTime
  us_payment_time: DateTime
  is_locked: boolean
  has_sent_to_processing: boolean
  is_synced: boolean
  recheck_status_sequence: number
  recheck_status_schedule_at: DateTime | null
  failed_at: DateTime | null
  platform: 'rc' | 'rm'
  device: 'web' | 'app'
  created_at: DateTime
  updated_at: DateTime
  transactions?: PaymentWallTransaction[] | null
  order_meta?: Order | null
  card_meta?: PaymentWallCard | null
}

export interface PaymentWallCard {
  id: number
  it_pg_channel: string | null
  gateway_card_id: string | null
  name: string | null
  last4: number | null
  network: string | null
  type: string | null
  issuer: string | null
  international: boolean | null
  emi: boolean | null
  sub_type: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface PaymentWallTransaction {
  id: number
  payment_id: number
  order_id: number
  amount: number
  opening_balance: number
  closing_balance: number
  type: 'credit' | 'debit'
  description: string
  created_at: DateTime
  updated_at: DateTime
}

export interface RecentSearch {
  id: number
  type: string
  payload: {}
  staff_id: number
  user_id: number
  created_at: DateTime
  updated_at: DateTime
}

export interface ReferEarnCreate {
  id: number
  user_id: number
  refer_earn_definition_id: number
  expiry_at: DateTime
  created_at: DateTime
  updated_at: DateTime
  referEarnDefinition?: ReferEarnDefinition | null
  userMeta?: User | null
  urlStats?: ReferEarnUrlStat[] | null
  onboards?: ReferEarnOnboard[] | null
  credits?: ReferEarnCredit[] | null
}

export interface ReferEarnCredit {
  id: number
  refer_earn_onboard_id: number
  refer_earn_create_id: number
  refer_from_user_id: number
  wallet_type: 'money' | 'promo' | 'voucher'
  wallet_id: number
  amount: number
  created_at: DateTime
  updated_at: DateTime
  walletMeta?: Wallet | null
}

export interface ReferEarnDefinition {
  id: number
  hook_code: 'GET10p5v_GIVE50p' | 'GET10v_GIVE50p' | 'GET20p_GIVE50p' | 'GET10p2v_GIVE20p' | 'GET2v_GIVE2v'
  title: string
  description_give: string
  description_get: string
  is_active: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface ReferEarnOnboard {
  id: number
  refer_earn_create_id: number
  refer_from_user_id: number
  refer_to_user_id: number
  status: 'signup' | 'completed' | 'cexpired' | null
  undefined: any
  created_at: DateTime
  updated_at: DateTime
  referEarnCreate?: ReferEarnCreate | null
  onboards?: ReferEarnCredit[] | null
  credits?: ReferEarnCredit[] | null
  referToUserMeta?: User | null
}

export interface ReferEarnUrlStat {
  id: number
  refer_earn_create_id: number
  ip_address: string
  user_agent: string
  created_at: DateTime
  updated_at: DateTime
}

export interface ReviewPrompt {
  id: number
  platform: 'rc' | 'rm'
  platform_os: 'web' | 'ios' | 'android' | 'windows' | 'macos'
  device: 'web' | 'app'
  user_id: number | undefined
  guest_uuid: string | null
  device_uuid: string | null
  user_ip: string | null
  initiator_reason: 'order' | 'cashback'
  type: 'in-app' | 'external'
  external_review_url: string | null
  created_at: DateTime
  updated_at: DateTime
}

export interface ScratchCoupon {
  id: number
  website_domain: string
  hook: string | number | symbol
  title: string
  subtitle: string
  heading: string
  static_coupon_code: string | null
  static_validity_date: DateTime | null
  static_valid_days: number | null
  static_coupon_type: string | null
  details: string | null
  terms: string | null
  redeem_target: 'self' | 'url'
  redeem_url: string | null
  ui_tag: 'wallet' | 'coupon' | null
  created_at: DateTime
  updated_at: DateTime
  website?: Website | null
}

export interface ScratchMyReward {
  id: number
  website_domain: string
  hook: string | number | symbol
  user_id: number | null
  guest_uuid: string | null
  device_uuid: string | null
  order_id: number | null
  is_scratched: boolean
  is_better_luck_next_time: boolean
  scratch_coupon_json: {
    id: number
    created_at: DateTime
    updated_at: DateTime
    title: string
    subtitle: string
    website_domain: string
    hook: string | number | symbol
    heading: string
    static_coupon_code: string | null
    static_validity_date: DateTime | null
    static_valid_days: number | null
    static_coupon_type: string | null
    details: string | null
    terms: string | null
    redeem_target: 'self' | 'url'
    redeem_url: string | null
    ui_tag: 'wallet' | 'coupon' | null
  }
  expires_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  scratchMyRewardCashback?: ScratchMyRewardCashback | null
  website?: Website | null
}

export interface ScratchMyRewardCashback {
  id: number
  scratch_my_reward_id: number
  user_id: number | null
  guest_uuid: string | null
  device_uuid: string | null
  wallet_type: 'money' | 'promo' | 'voucher'
  amount: number
  transaction_amount: number
  should_consider_in_wallet: boolean
  is_redeemed: boolean
  created_at: DateTime
  updated_at: DateTime
  userMeta?: User | null
}

export interface Staff {
  id: number
  email: string
  mobile: string
  name: string
  role: string
  password: string
  rememberMeToken: string | undefined
  created_at: DateTime
  updated_at: DateTime
  is_active: boolean
  pin: number | null
  notifications?: Notification[] | null
  notificationSubscriptions?: NotificationSubscription[] | null
  recentSearches?: RecentSearch[] | null
}

export interface StaffNote {
  id: number
  staff_id: number
  reference_type: 'order' | 'user'
  reference_id: number
  note: string
  created_at: DateTime
  updated_at: DateTime
}

export interface StaticState {
  id: number
  type: string
  name: string
  country_code: string
  state_code: string
  iso_3166_2: string
  vehicle_code: string
  zone: string
  gst_code: string
  created_at: DateTime
  updated_at: DateTime
}

export interface StorageDisk {
  id: number
  type: 's3' | 'disk'
  public_url: string | null
  createdAt: DateTime
  updatedAt: DateTime
}

export interface User {
  id: number
  name: string
  email: string
  mobile: string
  is_email_verified: boolean
  is_mobile_verified: boolean
  is_profile_completed: boolean
  is_security_locked: boolean
  has_completed_kyc: boolean
  undefined: any
  password: string
  rememberMeToken: string | undefined
  platform: 'rc' | 'rm'
  device: 'web' | 'app'
  signup_ip: string | null
  gender: 'other' | 'male' | 'female'
  birth_date: DateTime
  created_at: DateTime
  updated_at: DateTime
  referPrefix: number | undefined
  wallet?: Wallet[] | null
  orders?: Order[] | null
  referEarnOnboard?: ReferEarnOnboard | null
  referEarnCreates?: ReferEarnCreate[] | null
  notifications?: Notification[] | null
  notificationSubscriptions?: NotificationSubscription[] | null
  primaryBillDetail?: UserBillDetail | null
  bill_details?: UserBillDetail[] | null
  otpValidations?: OtpValidation[] | null
  userKyc?: UserKyc | null
  userLimit?: UserLimit[] | null
  userKycFullTickets?: UserKycFullTicket[] | null
  scratchMyRewards?: ScratchMyReward[] | null
  scratchMyRewardCashbacks?: ScratchMyRewardCashback[] | null
}

export interface UserBillDetail {
  id: number
  user_id: number
  legal_name: string
  tax_gst_number: string | null
  tax_pan_number: string | null
  tax_gst_state_code: string
  tax_country_code: string
  mobile_number: string
  email: string
  addressLine1: string | null
  addressLine2: string | null
  addressLine3: string | null
  city: string
  state: string
  pin_code: string
  country: string
  is_primary: boolean
  created_at: DateTime
  updated_at: DateTime
}

export interface UserKyc {
  id: number
  user_id: number
  verified_aadhaar_no: string | null
  verified_pan_no: string | null
  verified_full_kyc_ticket_id: number | null
  created_at: DateTime
  updated_at: DateTime
  user_meta?: User | null
}

export interface UserKycAadhaarRequest {
  id: number
  user_id: number
  aadhaar_no: string
  ref_id: string
  hook_code: 'cashfree'
  verification_response: any
  status: 'pending' | 'success' | 'failed'
  created_at: DateTime
  updated_at: DateTime
  userMeta?: User | null
}

export interface UserKycFullTicket {
  id: number
  user_id: number
  freshdesk_ticket_id: number
  status: 'pending' | 'success' | 'failed'
  created_at: DateTime
  updated_at: DateTime
  user_meta?: User | null
}

export interface UserKycPanRequest {
  id: number
  pan_no: string
  user_id: number
  hook_code: 'cashfree'
  status: 'pending' | 'success' | 'failed'
  verification_response: any
  created_at: DateTime
  updated_at: DateTime
  userMeta?: User | null
}

export interface UserLimit {
  id: number
  user_id: number
  module_type: 'wallet'
  module_subtype: string
  utilized_limit_start_date: DateTime
  limit_period: 'monthly'
  limit_amount: number
  utilized_limit_amount: number
  created_at: DateTime
  updated_at: DateTime
}

export interface Utm {
  id: number
  utm_source: string
  utm_medium: string
  utm_campaign: string
  short_code: string
  processing_fee_percent: number
  processing_fee_flat: number
  processing_fee_max: number
  config: {}
  created_at: DateTime
  updated_at: DateTime
}

export interface Wallet {
  id: number
  user_id: number
  balance: number
  is_locked: boolean
  currency: 'INR'
  type: 'money' | 'promo' | 'voucher'
  default_order: number
  created_at: DateTime
  updated_at: DateTime
  statement?: WalletTransaction[] | null
}

export interface WalletTransaction {
  id: number
  wallet_id: number
  service: string
  service_id: number
  service_date: DateTime
  service_provider_id: number
  type: 'credit' | 'debit'
  amount: number
  opening_balance: number
  closing_balance: number
  created_at: DateTime
  undefined: any
  updated_at: DateTime
}

export interface WalletVoucher {
  id: number
  provider_id: number
  code: string
  wallet_type: 'money' | 'promo' | 'voucher'
  amount: number
  status: 'pending' | 'applied'
  user_id: number | null | undefined
  staff_id: number | null | undefined
  is_locked: boolean
  expiry_at: DateTime
  applied_at: DateTime | null
  created_at: DateTime
  updated_at: DateTime
  user_meta?: User | null
}

/**
 * Routes used in the project
 */
export interface APP_ROUTES {
  ADMIN_AUTH_LOGIN: {
    request: {
      header: any
      validation: {
        email: string
        password: string
        remember_me: boolean | undefined
      }
    }
    response: { code: 200; token: { token: string }; staff: Staff }
  }

  ADMIN_AUTH_CHECK: {
    request: {
      header: any
      validation: any
    }
    response: {
      code: 200
      staff: Staff
      recentSearches: { [k: string]: Object }
    }
  }

  ADMIN_AUTH_LOGOUT: {
    request: {
      header: any
      validation: any
    }
    response: { code: 200 }
  }

  ADMIN_ANALYTICS_BASIC: {
    request: {
      header: any
      validation: {
        from: DateTime
        to: DateTime
        device: 'web' | 'app' | undefined
        platform: 'rc' | 'rm' | undefined
        is_operator_wise: boolean | undefined
      }
    }
    response: {
      code: 200
      data: {
        userMeta: {
          total_count: number
          is_email_verified: number
          is_mobile_verified: number
          is_profile_completed: number
        }
        orderMeta: Partial<{
          wallet: {
            sub_item_code: number
            name: string
            data: Partial<{
              none: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              dispatched: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              processing: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              pending: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              success: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              failed: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              review: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
            }>
          }[]
          visa: {
            sub_item_code: number
            name: string
            data: Partial<{
              none: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              dispatched: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              processing: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              pending: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              success: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              failed: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              review: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
            }>
          }[]
          manual: {
            sub_item_code: number
            name: string
            data: Partial<{
              none: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              dispatched: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              processing: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              pending: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              success: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              failed: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
              review: {
                count: number
                base_amount: number
                discount: number
                total_amount: number
                processing_fee: number
              }
            }>
          }[]
        }>
        referMeta: Partial<{
          signup: { count: number }
          completed: { count: number }
          cexpired: { count: number }
        }>
        is_operator_wise: boolean
      }
    }
  }

  ADMIN_REPORT_SALE: {
    request: {
      header: any
      validation: {
        from: DateTime
        to: DateTime
      }
    }
    response: { code: 200; data: string }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_LIST: {
    request: {
      header: any
      validation: {
        search: string | undefined
        page: number
        perPage: number
        orderBy: 'id' | 'campaign_id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<GoogleAdsCampaign> }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_CREATE: {
    request: {
      header: any
      validation: {
        campaign_id: number
        campaign_name: string
        item: 'wallet' | 'visa' | 'manual'
        sub_item_code: number
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: GoogleAdsCampaign; message?: undefined }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        campaign_id: number
        campaign_name: string
        item: 'wallet' | 'visa' | 'manual'
        sub_item_code: number
      }
    }
    response: { code: 200; data: GoogleAdsCampaign }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200 }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_RECHECKSTATUS: {
    request: {
      header: any
      validation: {
        ids: number[] | undefined
      }
    }
    response: { code: 200; data: GoogleAdsCampaign[] }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_ENABLE: {
    request: {
      header: any
      validation: {
        ids: number[] | undefined
      }
    }
    response: { code: 200; data: GoogleAdsCampaign[] }
  }

  ADMIN_ADS_GOOGLE_CAMPAIGN_DISABLE: {
    request: {
      header: any
      validation: {
        ids: number[] | undefined
      }
    }
    response: { code: 200; data: GoogleAdsCampaign[] }
  }

  ADMIN_STAFF_NOTES_LIST: {
    request: {
      header: any
      validation: {
        staff_id: number | undefined
        reference_type: string | undefined
        reference_id: number | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<StaffNote> }
  }

  ADMIN_STAFF_NOTES_CREATE: {
    request: {
      header: any
      validation: {
        reference_type: 'order' | 'user'
        reference_id: number
        note: string
      }
    }
    response: { code: 200; data: StaffNote }
  }

  ADMIN_STAFF_NOTES_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: StaffNote }
  }

  ADMIN_STAFF_NOTES_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        note: string
      }
    }
    response: { code: 200; data: StaffNote }
  }

  ADMIN_STAFF_LIST: {
    request: {
      header: any
      validation: {
        name: string | undefined
        email: string | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: { code: 200; data: ModelPaginatorContract<Staff> }
  }

  ADMIN_STAFF_CREATE: {
    request: {
      header: any
      validation: {
        name: string
        is_active: boolean
        email: string
        mobile: string
        role: string
        password: string
        pin: number
      }
    }
    response: { code: 200; data: Staff }
  }

  ADMIN_STAFF_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        name: string
        is_active: boolean
        email: string
        mobile: string
        role: string
        password: string | undefined
        pin: number
      }
    }
    response: { code: 200; data: Staff }
  }

  ADMIN_STAFF_DELETE: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  ADMIN_USER_LIST: {
    request: {
      header: any
      validation: {
        id: number | undefined
        name: string | undefined
        mobile: string | undefined
        email: string | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
        is_security_locked: boolean | undefined
        has_completed_kyc: boolean | undefined
        device: 'web' | 'app' | undefined
        platform: 'rc' | 'rm' | undefined
        guest_uuid: string | undefined
        device_uuid: string | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<User> }
  }

  ADMIN_USER_UPDATEBLOCK: {
    request: {
      header: any
      validation: {
        user_id: number
        is_blocked: boolean
      }
    }
    response: { code: 200; data: User }
  }

  ADMIN_USER_UPDATEKYC: {
    request: {
      header: any
      validation: {
        user_id: number
        is_completed: boolean
      }
    }
    response: { code: 200; data: User }
  }

  ADMIN_USER_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: { code: 200; data: User }
  }

  ADMIN_USER_KYC_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
        user_id: number | undefined
        verified_aadhaar_no: string | undefined
        verified_pan_no: string | undefined
        verified_full_kyc_ticket_id: number | undefined
      }
    }
    response: {
      code: 200
      data: ModelPaginatorContract<
        UserKyc & {
          panResponse: UserKycPanRequest | null
          aadhaarResponse: UserKycAadhaarRequest | null
          id: number
          created_at: DateTime
          updated_at: DateTime
          user_id: number
          verified_aadhaar_no: string | null
          verified_pan_no: string | null
          verified_full_kyc_ticket_id: number | null
        }
      >
    }
  }

  ADMIN_USER_KYC_FULLTICKET_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
        user_id: number | undefined
        freshdesk_ticket_id: number | undefined
        status: 'pending' | 'success' | 'failed' | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<UserKycFullTicket> }
  }

  ADMIN_USER_KYC_FULLTICKET_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        user_id: number
        freshdesk_ticket_id: number
        status: 'success' | 'failed'
      }
    }
    response: { code: 200; data: UserKycFullTicket }
  }

  ADMIN_USER_KYC_FULLTICKET_CREATE: {
    request: {
      header: any
      validation: {
        user_id: number
        freshdesk_ticket_id: number
        status: 'success' | 'failed'
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: UserKycFullTicket; message?: undefined }
  }

  ADMIN_USER_LIMIT_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        user_id: number
        limit_amount: number
      }
    }
    response: { code: 200; data: UserLimit }
  }

  ADMIN_PAYMENT_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
        amount: number | undefined
        it_pg_channel: 'cashfree' | 'self' | 'payubiz' | 'razorpay' | undefined
        payment_status: 'pending' | 'success' | 'failed' | 'cancelled' | undefined
        order_id: number | undefined
        gateway_payment_id: string | undefined
        gateway_payment_id2: string | undefined
        pg_method: string | undefined
        pg_sub_gateway_provider: string | undefined
        pg_bank_utr: string | undefined
        pg_vpa: string | undefined
        pg_bank: string | undefined
        pg_wallet: string | undefined
        user_id: number | undefined
        card:
          | {
              it_pg_channel: 'cashfree' | 'payubiz' | 'razorpay' | undefined
              gateway_card_id: string | undefined
              name: string | undefined
              last4: number | undefined
              network: string | undefined
              type: string | undefined
              issuer: string | undefined
              international: boolean | undefined
              emi: boolean | undefined
              sub_type: string | undefined
            }
          | undefined
        from: DateTime | undefined
        to: DateTime | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<PaymentWall> }
  }

  ADMIN_PAYMENT_LISTSEARCHMETA: {
    request: {
      header: any
      validation: any
    }
    response: {
      code: 200
      data: {
        pg_bank: string[]
        pg_wallet: string[]
        pg_method: string[]
        pg_sub_gateway_provider: string[]
        card: {
          network: string[]
          type: string[]
          issuer: string[]
          sub_type: string[]
        }
      }
    }
  }

  ADMIN_ORDER_GET: {
    request: {
      header: any
      validation: {
        id: number
      }
    }
    response: {
      code: 200
      data: Order & {
        pgStat: orderPGStatType
        refunds: { api_res_data: any }[]
      }
    }
  }

  ADMIN_ORDER_LIST: {
    request: {
      header: any
      validation: {
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
        order:
          | {
              id: number | undefined
              payment_status: string | undefined
              device: 'web' | 'app' | undefined
              platform: 'rc' | 'rm' | undefined
              guest_uuid: string | undefined
              device_uuid: string | undefined
              from: DateTime | undefined
              to: DateTime | undefined
            }
          | undefined
        user:
          | {
              id: number | undefined
              mobile: string | undefined
              email: string | undefined
            }
          | undefined
        order_item:
          | {
              id: number | undefined
              item: 'wallet' | 'visa' | 'manual' | undefined
              sub_item_code: string | undefined
              operator_ref: string | undefined
              base_amount: number | undefined
              total_amount: number | undefined
              delivery_status: 'none' | 'dispatched' | 'processing' | 'pending' | 'success' | 'failed' | 'review' | undefined
            }
          | undefined
        order_item_visa: { country_code: string | undefined; source_key: string | undefined } | undefined
        order_item_wallet: { amount: number | undefined } | undefined
        order_refunds:
          | {
              mode: string | undefined
              amount: number | undefined
              status: string | undefined
              bank_ref: string | undefined
            }
          | undefined
        bill_detail:
          | {
              legal_name: string | undefined
              tax_gst_number: string | undefined
              tax_pan_number: string | undefined
              tax_gst_state_code: string | undefined
              tax_country_code: string | undefined
              mobile_number: string | undefined
              email: string | undefined
            }
          | undefined
        payment_wall: { id: number | undefined } | undefined
      }
    }
    response: {
      code: 200
      data: ModelPaginatorContract<Order & { pgStat: orderPGStatType }>
    }
  }

  ADMIN_ORDER_ONHOLDPAYMENTACTION: {
    request: {
      header: any
      validation: {
        order_id: number
        action: 'withdraw' | 'process'
        withdraw_destination: 'wallet' | 'manual' | 'cashgram' | 'original' | undefined
        comment: string | undefined
      }
    }
    response: { code: number }
  }

  ADMIN_ORDER_ITEM_RECHECKSINGLEITEM: {
    request: {
      header: any
      validation: {
        order_item_id: number
      }
    }
    response: { code: 200; data: OrderItem }
  }

  ADMIN_ORDER_ITEM_RECHECKSINGLEITEMDEBUGLOGS: {
    request: {
      header: any
      validation: {
        order_item_id: number
      }
    }
    response: { code: 200; data: string }
  }

  ADMIN_ORDER_ITEM_UPDATESINGLEITEMSTATUS: {
    request: {
      header: any
      validation: {
        order_item_id: number
        delivery_status: 'success' | 'failed'
        operator_ref: string | undefined
        comment: string | undefined
      }
    }
    response: { code: 200; data: OrderItem }
  }

  ADMIN_ORDER_TRAVELER_UPDATETRAVELER: {
    request: {
      header: any
      validation: {
        order_id: number
        order_hash: string
        traveler_id: number
        traveler_meta: {
          first_name: string
          last_name: string
          mobile_no: string | undefined
          email: string | undefined
          pan_no: string | undefined
          passport_no: string | undefined
          documents:
            | {
                document_type: string
                document_id: number
                document_hash: string
              }[]
            | undefined
        }
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: Order; message?: undefined }
  }

  ADMIN_ORDER_TRAVELER_UPDATEVISA: {
    request: {
      header: any
      validation: {
        order_id: number
        order_hash: string
        traveler_id: number
        document_id: number
        document_hash: string
        visa_final_status: 'pending' | 'success' | 'rejected'
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: Order; message?: undefined }
  }

  ADMIN_ORDER_PAYMENT_RECHECKSINGLESTATUS: {
    request: {
      header: any
      validation: {
        payment_wall_id: number
      }
    }
    response: { code: 200; data: PaymentWall }
  }

  ADMIN_ORDER_PAYMENT_RECHECKALLSTATUS: {
    request: {
      header: any
      validation: {
        order_id: number
      }
    }
    response: { code: 200; data: PaymentWall[] }
  }

  ADMIN_ORDER_REFUND_RECHECKSINGLESTATUS: {
    request: {
      header: any
      validation: {
        refund_id: number
      }
    }
    response: { code: 200; data: OrderRefund; additionalInfo: any }
  }

  ADMIN_ORDER_REFUND_RECHECKALLSTATUS: {
    request: {
      header: any
      validation: {
        order_id: number
      }
    }
    response: { code: 200; data: OrderRefund[] }
  }

  ADMIN_WALLET_STATEMENT: {
    request: {
      header: any
      validation: {
        wallet_type: 'money' | 'promo' | 'voucher'
        user_id: number
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
      }
    }
    response: {
      code: 200
      data: ModelPaginatorContract<WalletTransaction & { title: string }>
    }
  }

  ADMIN_WALLET_DEDUCT: {
    request: {
      header: any
      validation: {
        user_id: number
        amount: number
        type: 'credit' | 'debit'
        wallet_type: 'money' | 'promo' | 'voucher'
        reason: string
      }
    }
    response: { code: number; message: string } | { code: 200; message?: undefined }
  }

  ADMIN_WALLET_VOUCHER_LIST: {
    request: {
      header: any
      validation: {
        user: { mobile: string | undefined; email: string | undefined } | undefined
        page: number
        perPage: number
        orderBy: string
        orderDirection: string
        code: string | undefined
        wallet_type: 'money' | 'promo' | 'voucher' | undefined
      }
    }
    response: { code: 200; data: ModelPaginatorContract<WalletVoucher> }
  }

  ADMIN_WALLET_VOUCHER_CREATE: {
    request: {
      header: any
      validation: {
        user_id: number | undefined
        wallet_type: 'promo' | 'voucher'
        amount: number
        expireAfterDays: number
      }
    }
    response: { code: 200; data: WalletVoucher }
  }

  ADMIN_WALLET_VOUCHER_APPLY: {
    request: {
      header: any
      validation: {
        user_id: number
        code: string
      }
    }
    response: { code: 200 }
  }

  ADMIN_STATICDATA_VISA_GET: {
    request: {
      header: any
      validation: {
        country_code: string | undefined
        slug: string | undefined
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: CountryVisaDetail; message?: undefined }
  }

  ADMIN_STATICDATA_VISA_GETBYID: {
    request: {
      header: {}
      validation: {
        id: number
      }
    }
    response: { code: 200; data: CountryVisaDetail }
  }

  ADMIN_STATICDATA_VISA_LIST: {
    request: {
      header: {}
      validation: {
        country_code: string
        page: number
        perPage: number
        orderBy: string
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<CountryVisaDetail> }
  }

  ADMIN_STATICDATA_VISA_UPDATE: {
    request: {
      header: any
      validation: {
        id: number
        name: string
        child_fee_inr: number
        visa_fee_inr: number
        visa_child_fee_inr: number
        service_fee_per_person: number
        priority: number
        eta_duration: number
        eta_unit: 'month' | 'day' | 'hour' | 'minute' | 'months' | 'days' | 'hours' | 'minutes'
        eta_b2b_duration: number
        eta_b2b_unit: 'month' | 'day' | 'hour' | 'minute' | 'months' | 'days' | 'hours' | 'minutes'
      }
    }
    response: { code: 200; data: CountryVisaDetail }
  }

  ADMIN_STATICDATA_COUNTRYHOLIDAY_GET: {
    request: {
      header: {}
      validation: {
        id: number
      }
    }
    response: { code: 200; data: CountryHoliday }
  }

  ADMIN_STATICDATA_COUNTRYHOLIDAY_LIST: {
    request: {
      header: {}
      validation: {
        country_code: string | undefined
        page: number
        perPage: number
        orderBy: 'id'
        orderDirection: 'asc' | 'desc'
      }
    }
    response: { code: 200; data: ModelPaginatorContract<CountryHoliday> }
  }

  ADMIN_STATICDATA_COUNTRYHOLIDAY_CREATE: {
    request: {
      header: {}
      validation: {
        country_code: string
        holiday_date: DateTime
        reason: string
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: CountryHoliday; message?: undefined }
  }

  ADMIN_STATICDATA_COUNTRYHOLIDAY_UPDATE: {
    request: {
      header: {}
      validation: {
        id: number
        country_code: string
        holiday_date: DateTime
        reason: string
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: CountryHoliday; message?: undefined }
  }

  ADMIN_STATICDATA_COUNTRYHOLIDAY_DELETE: {
    request: {
      header: {}
      validation: {
        id: number
      }
    }
    response: { code: 200; message: string }
  }

  FILE_UPLOAD: {
    request: {
      header: {}
      validation: {
        attachment: MultipartFileContract
      }
    }
    response: { code: 200; data: FileUpload }
  }

  FILE_GETFILES: {
    request: {
      header: {}
      validation: {
        ids: number[]
      }
    }
    response: { code: 200; data: FileUpload[] }
  }

  FILE_GET: {
    request: {
      header: {}
      validation: {
        id: number
        hash: string
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: FileUpload; message?: undefined }
  }

  FILE_DELETE: {
    request: {
      header: {}
      validation: {
        id: number
        hash: string
      }
    }
    response: { code: 500; message: string; data?: undefined } | { code: 200; data: FileUpload; message?: undefined }
  }
}

/**
 * URLs for usage of further development
 */
type AppUrlType = {
  [U in keyof APP_ROUTES]: {
    url: string
    headers: Object
    method: string
  }
}

export const APP_URLS: AppUrlType = {
  ADMIN_AUTH_LOGIN: {
    url: '/admin/auth/login',
    headers: {},
    method: 'POST',
  },
  ADMIN_AUTH_CHECK: {
    url: '/admin/auth/check',
    headers: {},
    method: 'POST',
  },
  ADMIN_AUTH_LOGOUT: {
    url: '/admin/auth/logout',
    headers: {},
    method: 'POST',
  },
  ADMIN_ANALYTICS_BASIC: {
    url: '/admin/analytics/basic',
    headers: {},
    method: 'POST',
  },
  ADMIN_REPORT_SALE: {
    url: '/admin/report/sale',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_LIST: {
    url: '/admin/ads/google/campaign/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_CREATE: {
    url: '/admin/ads/google/campaign/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_UPDATE: {
    url: '/admin/ads/google/campaign/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_DELETE: {
    url: '/admin/ads/google/campaign/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_RECHECKSTATUS: {
    url: '/admin/ads/google/campaign/recheck-status',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_ENABLE: {
    url: '/admin/ads/google/campaign/enable',
    headers: {},
    method: 'POST',
  },
  ADMIN_ADS_GOOGLE_CAMPAIGN_DISABLE: {
    url: '/admin/ads/google/campaign/disable',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_LIST: {
    url: '/admin/staff/notes/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_CREATE: {
    url: '/admin/staff/notes/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_DELETE: {
    url: '/admin/staff/notes/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_NOTES_UPDATE: {
    url: '/admin/staff/notes/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_LIST: {
    url: '/admin/staff/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_CREATE: {
    url: '/admin/staff/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_UPDATE: {
    url: '/admin/staff/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STAFF_DELETE: {
    url: '/admin/staff/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_LIST: {
    url: '/admin/user/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_UPDATEBLOCK: {
    url: '/admin/user/updateBlock',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_UPDATEKYC: {
    url: '/admin/user/updateKyc',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_GET: {
    url: '/admin/user/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_LIST: {
    url: '/admin/user/kyc/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_FULLTICKET_LIST: {
    url: '/admin/user/kyc/full-ticket/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_FULLTICKET_UPDATE: {
    url: '/admin/user/kyc/full-ticket/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_KYC_FULLTICKET_CREATE: {
    url: '/admin/user/kyc/full-ticket/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_USER_LIMIT_UPDATE: {
    url: '/admin/user/limit/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_PAYMENT_LIST: {
    url: '/admin/payment/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_PAYMENT_LISTSEARCHMETA: {
    url: '/admin/payment/listSearchMeta',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_GET: {
    url: '/admin/order/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_LIST: {
    url: '/admin/order/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ONHOLDPAYMENTACTION: {
    url: '/admin/order/onHoldPaymentAction',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ITEM_RECHECKSINGLEITEM: {
    url: '/admin/order/item/recheckSingleItem',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ITEM_RECHECKSINGLEITEMDEBUGLOGS: {
    url: '/admin/order/item/recheckSingleItemDebugLogs',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_ITEM_UPDATESINGLEITEMSTATUS: {
    url: '/admin/order/item/updateSingleItemStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_TRAVELER_UPDATETRAVELER: {
    url: '/admin/order/traveler/updateTraveler',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_TRAVELER_UPDATEVISA: {
    url: '/admin/order/traveler/updateVisa',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_PAYMENT_RECHECKSINGLESTATUS: {
    url: '/admin/order/payment/recheckSingleStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_PAYMENT_RECHECKALLSTATUS: {
    url: '/admin/order/payment/recheckAllStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_REFUND_RECHECKSINGLESTATUS: {
    url: '/admin/order/refund/recheckSingleStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_ORDER_REFUND_RECHECKALLSTATUS: {
    url: '/admin/order/refund/recheckAllStatus',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_STATEMENT: {
    url: '/admin/wallet/statement',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_DEDUCT: {
    url: '/admin/wallet/deduct',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_VOUCHER_LIST: {
    url: '/admin/wallet/voucher/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_VOUCHER_CREATE: {
    url: '/admin/wallet/voucher/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_WALLET_VOUCHER_APPLY: {
    url: '/admin/wallet/voucher/apply',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_VISA_GET: {
    url: '/admin/static-data/visa/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_VISA_GETBYID: {
    url: '/admin/static-data/visa/getById',
    headers: {},
    method: 'POST',
  },

  ADMIN_STATICDATA_VISA_LIST: {
    url: '/admin/static-data/visa/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_VISA_UPDATE: {
    url: '/admin/static-data/visa/update',
    headers: {},
    method: 'POST',
  },
  FILE_UPLOAD: {
    url: '/file/upload',
    headers: {},
    method: 'POST',
  },
  FILE_GETFILES: {
    url: '/file/getFiles',
    headers: {},
    method: 'POST',
  },
  FILE_GET: {
    url: '/file/get',
    headers: {},
    method: 'POST',
  },
  FILE_DELETE: {
    url: '/file/delete',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUNTRYHOLIDAY_GET: {
    url: '/admin/static-data/country-holiday/get',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUNTRYHOLIDAY_LIST: {
    url: '/admin/static-data/country-holiday/list',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUNTRYHOLIDAY_CREATE: {
    url: '/admin/static-data/country-holiday/create',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUNTRYHOLIDAY_UPDATE: {
    url: '/admin/static-data/country-holiday/update',
    headers: {},
    method: 'POST',
  },
  ADMIN_STATICDATA_COUNTRYHOLIDAY_DELETE: {
    url: '/admin/static-data/country-holiday/delete',
    headers: {},
    method: 'POST',
  },
}

export type getValidationType<T extends keyof APP_ROUTES> = ReplaceUndefinedWithNull<APP_ROUTES[T]['request']['validation']>
export type getResponseType<T extends keyof APP_ROUTES> = APP_ROUTES[T]['response']

/**
 * Request Approach
 */

export type fetchFunctionType = <T extends keyof APP_ROUTES>(
  url: string,
  headers: APP_ROUTES[T]['request']['header'],
  body: APP_ROUTES[T]['request']['validation'],
  abortSignal?: AbortSignal | undefined | null
) => Promise<APP_ROUTES[T]['response']>

export class Request {
  fn: fetchFunctionType
  constructor(fn: fetchFunctionType) {
    this.fn = fn
  }

  send<T extends keyof APP_ROUTES>(
    key: T,
    data: {
      headers?: APP_ROUTES[T]['request']['header']
      body: APP_ROUTES[T]['request']['validation']
    },
    signal?: AbortSignal | undefined | null
  ): Promise<APP_ROUTES[T]['response']> {
    return this.fn(APP_URLS[key]['url'], data.headers, data.body, signal)
  }
}

/** 
 *  Example approach
 *
  const fn: fetchFunctionType = async (url, headers, body) => {
    url
    body
    headers
    return null as any
  }
  
  const request = new Request(fn)
  request.send('TAG_TEST', { headers: {}, body: { test: 1 } }) 
*/
